import { CalculCodeStateKeys } from '@batical/types'

export type Sections =
  | 'S15BOIS'
  | 'S00GAZ'
  | 'S01ECS'
  | 'S03AIR'
  | 'S02BILANFINECO'
  | 'S04CHAUDIERE'
  | 'S06DECHYDRO'
  | 'S07RADIATEUR'
  | 'S08VASEEXPANSION'
  | 'S09CIRCULATEUR'
  | 'S10TUYAUTERIE'
  | 'S11PERTECHARGE'
  | 'S12VOLINSTCHAUF'
  | 'S13CHAUFFERIE'
  | 'S14VANNE'
  | 'S16TRAITEMENTDEAU'
  | 'S17COGENERATION'
  //added by generator
  | 'S21RENDEMENT'
  //[MARKER_NEW_SECTION]
  | 'S18VENTILATION'

export const sectionsBatiKal: Array<Sections> = [
  'S15BOIS',
  'S00GAZ',
  'S01ECS',
  'S03AIR',
  'S02BILANFINECO',
  'S04CHAUDIERE',
  'S06DECHYDRO',
  'S07RADIATEUR',
  'S08VASEEXPANSION',
  'S09CIRCULATEUR',
  'S10TUYAUTERIE',
  'S11PERTECHARGE',
  'S12VOLINSTCHAUF',
  'S13CHAUFFERIE',
  'S14VANNE',
  'S16TRAITEMENTDEAU',
  'S17COGENERATION',
  //added by generator
  'S21RENDEMENT',
  //[MARKER_NEW_SECTION]
  'S18VENTILATION'
]

export const calculBySections: { [key: string]: { calculs: Array<CalculCodeStateKeys> } } = {
  S00GAZ: {
    calculs: ['I00DEBGAZ', 'I00RELGAZPUISS', 'I00DIMLIGNEGAZ']
  },
  S01ECS: {
    calculs: ['I01EVACONSSYSTECS2', 'I01EVACONSSYSTECS', 'I01EVAECSQUALI', 'I01EVAECSQUALI2', 'I01EVAECSQUALI3']
  },
  S02BILANFINECO: {
    calculs: ['I02CHOIXENERCHAUF', 'I02COSTENER']
  },
  S03AIR: {
    calculs: ['I03PSYCHROAIR']
  },
  S04CHAUDIERE: {
    calculs: [
      'I04DIMPUISSCHAUD',
      'I04DIMPUISCONS',
      'I04CONVVOLENER',
      'I04CONCLIMCONS',
      'I04CONSCHAUFAN',
      'I04CALCULGSIMP',
      'I04CALCULGDETA'
    ]
  },
  S06DECHYDRO: {
    calculs: ['I06SEPHYD']
  },
  S07RADIATEUR: {
    calculs: ['I07CALCPUISSRAD']
  },
  S08VASEEXPANSION: {
    calculs: ['I08CALCVOLEXP']
  },
  S09CIRCULATEUR: {
    calculs: ['I09DIMCIRC']
  },
  S10TUYAUTERIE: {
    calculs: ['I10DIABOUCECS', 'I10DIAMPUISS', 'I01TEMPATT', 'I01DEPBOUCECS', 'I10DIAEFCOL']
  },
  S11PERTECHARGE: {
    calculs: ['I11PERCHADISCHA', 'I11PERCHARES', 'I11PERCHARVARI']
  },
  S13CHAUFFERIE: {
    calculs: ['I13VENTCHAUFFIOUL', 'I13VENTCHAUFGAZ', 'I13VENTCHAUFBOIS']
  },
  S12VOLINSTCHAUF: {
    calculs: ['I12VOLINSTCHAUF']
  },
  S14VANNE: {
    calculs: ['I14V3VREGUL', 'I14V2VREGUL']
  },
  S16TRAITEMENTDEAU: {
    calculs: ['I16DIMADOUCISSEURECS', 'I16DIMADOUCISSEURPRIM']
  },
  S17COGENERATION: {
    calculs: ['I17INFPARCONSEP', 'I17TARIFC16']
  },
  S18VENTILATION: {
    calculs: ['I18VENTGAINE']
  },
  //added from generator
  S21RENDEMENT: {
    calculs: ['I21RENDETAS']
  },
  S15BOIS: {
    calculs: ['I15MASVOLAPHUML', 'I15TEMPRELEVE', 'I15HYDROACCU', 'I15TEMPLIMITBOIS', 'I15DIMSILOBOIS', 'I15TAUXCOUVBOIS']
  }
  //[MARKER_CONTENT_NEW_SECTION]
}

export const calculsInfo: { [key: string]: { image: string; subscription: boolean; isNew: boolean } } = {
  I00DEBGAZ: {
    image: 'S00GAZ',
    subscription: false,
    isNew: false
  },
  I00RELGAZPUISS: {
    image: 'S00GAZ',
    subscription: false,
    isNew: false
  },
  I00DIMLIGNEGAZ: {
    image: 'S00GAZ',
    subscription: false,
    isNew: false
  },
  I01TEMPATT: {
    image: 'S10TUYAUTERIE',
    subscription: false,
    isNew: false
  },
  I01EVACONSSYSTECS: {
    image: 'S01ECS',
    subscription: false,
    isNew: false
  },
  I01DEPBOUCECS: {
    image: 'S10TUYAUTERIE',
    subscription: false,
    isNew: false
  },
  I01EVACONSSYSTECS2: {
    image: 'S01ECS',
    subscription: false,
    isNew: false
  },
  I01EVAECSQUALI: {
    image: 'S01ECS',
    subscription: false,
    isNew: false
  },
  I01EVAECSQUALI2: {
    image: 'S01ECS',
    subscription: false,
    isNew: false
  },
  I01EVAECSQUALI3: {
    image: 'S01ECS',
    subscription: false,
    isNew: false
  },
  I02CHOIXENERCHAUF: {
    image: 'S02BILANFINECO',
    subscription: false,
    isNew: false
  },
  I02COSTENER: {
    image: 'S02BILANFINECO',
    subscription: false,
    isNew: false
  },
  I03PSYCHROAIR: {
    image: 'S03AIR',
    subscription: false,
    isNew: false
  },
  I04DIMPUISSCHAUD: {
    image: 'S04CHAUDIERE',
    subscription: false,
    isNew: false
  },
  I04DIMPUISCONS: {
    image: 'S04CHAUDIERE',
    subscription: false,
    isNew: false
  },
  I04CONCLIMCONS: {
    image: 'S04CHAUDIERE',
    subscription: false,
    isNew: false
  },
  I04CONVVOLENER: {
    image: 'S04CHAUDIERE',
    subscription: false,
    isNew: false
  },
  I04CONSCHAUFAN: {
    image: 'S04CHAUDIERE',
    subscription: false,
    isNew: false
  },
  I06SEPHYD: {
    image: 'S06DECHYDRO',
    subscription: false,
    isNew: false
  },
  I07CALCPUISSRAD: {
    image: 'S07RADIATEUR',
    subscription: false,
    isNew: false
  },
  I08CALCVOLEXP: {
    image: 'S08VASEEXPANSION',
    subscription: false,
    isNew: false
  },
  I09DIMCIRC: {
    image: 'S09CIRCULATEUR',
    subscription: false,
    isNew: false
  },
  I10DIABOUCECS: {
    image: 'S10TUYAUTERIE',
    subscription: false,
    isNew: false
  },
  I10DIAMPUISS: {
    image: 'S10TUYAUTERIE',
    subscription: false,
    isNew: false
  },
  I11PERCHADISCHA: {
    image: 'S11PERTECHARGE',
    subscription: false,
    isNew: false
  },
  I11PERCHARES: {
    image: 'S11PERTECHARGE',
    subscription: false,
    isNew: false
  },
  I11PERCHARVARI: {
    image: 'S11PERTECHARGE',
    subscription: false,
    isNew: false
  },
  I12VOLINSTCHAUF: {
    image: 'S12VOLINSTCHAUF',
    subscription: false,
    isNew: false
  },
  I13VENTCHAUFFIOUL: {
    image: 'S13CHAUFFERIE',
    subscription: false,
    isNew: false
  },
  I13VENTCHAUFGAZ: {
    image: 'S13CHAUFFERIE',
    subscription: false,
    isNew: false
  },
  I14V3VREGUL: {
    image: 'S14VANNE',
    subscription: false,
    isNew: false
  },
  I14V2VREGUL: {
    image: 'S14VANNE',
    subscription: false,
    isNew: false
  },
  I16DIMADOUCISSEURECS: {
    image: 'S16TRAITEMENTDEAU',
    subscription: false,
    isNew: false
  },
  I16DIMADOUCISSEURPRIM: {
    image: 'S16TRAITEMENTDEAU',
    subscription: false,
    isNew: false
  },
  I17TARIFC16: {
    image: 'S17COGENERATION',
    subscription: false,
    isNew: false
  },
  I17INFPARCONSEP: {
    image: 'S17COGENERATION',
    subscription: false,
    isNew: false
  },
  I18VENTGAINE: {
    image: 'S18VENTILATION',
    subscription: false,
    isNew: false
  },
  //added by generator
  I21RENDETAS: {
    image: 'S21RENDEMENT',
    subscription: false,
    isNew: false
  },
  I04CALCULGSIMP: {
    image: 'S04CHAUDIERE',
    subscription: false,
    isNew: false
  },
  I04CALCULGDETA: {
    image: 'S04CHAUDIERE',
    subscription: false,
    isNew: false
  },
  I15MASVOLAPHUML: {
    image: 'S15BOIS',
    subscription: false,
    isNew: false
  },
  I15TEMPRELEVE: {
    image: 'S15BOIS',
    subscription: false,
    isNew: false
  },
  I15HYDROACCU: {
    image: 'S15BOIS',
    subscription: false,
    isNew: false
  },
  I15TEMPLIMITBOIS: {
    image: 'S15BOIS',
    subscription: false,
    isNew: false
  },
  I15DIMSILOBOIS: {
    image: 'S15BOIS',
    subscription: false,
    isNew: false
  },
  I15TAUXCOUVBOIS: {
    image: 'S15BOIS',
    subscription: false,
    isNew: false
  },
  I13VENTCHAUFBOIS: {
    image: 'S13CHAUFFERIE',
    subscription: false,
    isNew: false
  },
  I10DIAEFCOL: {
    image: 'S10TUYAUTERIE',
    subscription: false,
    isNew: true
  }
  //[MARKER_NEW_CALCUL]
}
